module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp12_0.8c588cb1.png";